// Store
import store from '@/store'
import { MUTATIONS as M } from '@/store/helpers'

export const hideLoader = (to, from, next) => {
  store.commit(M.updateLoaderVisibility, false)

  next()
}
